module.exports = __webpack_public_path__ + "img/ic_device_bed.97a22409.png";